import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSettings } from '../../../../store/app/appStore';
import { FAVORITE_SECTION_NAME } from '@repo/common';
import Image from '../../../../shared/components/Image';

import styles from './FavoritesSection.module.css';
import TransWithFallback from '../../../../shared/components/Translations/TransWrapper';

const EmptyFavoritesMessage: React.FC = () => {
    const { t } = useTranslation();
    const { mode } = useSettings();
    const favoriteSectionName = t(`sections.names.${FAVORITE_SECTION_NAME}`, FAVORITE_SECTION_NAME);
    const translationKey = mode === 'desktop' ? 'favourites.desktop_no_entry' : 'favourites.no_entry';

    return <div className={styles.emptyState}>
        <TransWithFallback
            i18nKey={translationKey}
            components={{
                img: <Image
                    src="/icons/favorites_icon"
                    manualAffix=".svg"
                    alt="Favorites icon"
                    className={styles.emptyImage}
                />,
                b: <b />,
            }}
            values={{ favoriteSectionName }}
        />
    </div>
}

export default EmptyFavoritesMessage;